import { collection, getDocs } from 'firebase/firestore';
import db from '../lib/firebaseDb';

// Define the CulturalExperience interface
export interface CulturalExperience {
  id: string;
  title: string;
  description: string;
  category: string;
  imageUrl: string;
  content?: string;
  locations?: string[];
}

// Fetch all cultural experiences
export const fetchCulturalExperiences = async (): Promise<CulturalExperience[]> => {
  try {
    const querySnapshot = await getDocs(collection(db, 'culturalExperiences'));
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as CulturalExperience[];
  } catch (error) {
    console.error('Error fetching cultural experiences:', error);
    throw error;
  }
};

// Fetch cultural experiences by category
export const fetchCultureByCategory = async (category: string): Promise<CulturalExperience[]> => {
  try {
    const experiences = await fetchCulturalExperiences();
    return experiences.filter(experience => experience.category === category);
  } catch (error) {
    console.error('Error fetching cultural experiences by category:', error);
    throw error;
  }
}; 